/*
  NBV2 Blog Posts -- in-place "Load more" (sections/nbv2-blog-posts.liquid).

  The button is a plain link to the next paginated page, so it still works
  without JS. Here it fetches that page, appends its cards to this section's
  grid and points itself at the following page (or removes itself on the last).
*/
if (!customElements.get('nbv2-blog-load-more')) {
  customElements.define(
    'nbv2-blog-load-more',
    class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
      }

      async onClick(event) {
        event.preventDefault();
        if (this.link.getAttribute('aria-busy') === 'true') return;

        const url = this.link.href;
        const selector = `#shopify-section-${this.dataset.sectionId}`;
        const grid = this.closest(selector)?.querySelector('.nbv2-blog-posts__grid');

        this.link.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = doc.querySelector(selector);
          const items = section?.querySelectorAll('.nbv2-blog-posts__grid > .nbv2-blog-posts__item');
          if (!grid || !items?.length) throw new Error('No posts in response');

          grid.append(...items);

          const next = section.querySelector('nbv2-blog-load-more a');
          if (next) {
            this.link.setAttribute('href', next.getAttribute('href'));
            this.link.removeAttribute('aria-busy');
          } else {
            this.closest('.nbv2-blog-posts__more')?.remove();
          }
        } catch (error) {
          console.error(error);
          window.location.href = url;
        }
      }
    }
  );
}
